import { http, HttpResponse } from "msw";
// Mock BLAST endpoints data
const mockBLASTEndpoints = [
    {
        id: "550e8400-e29b-41d4-a716-446655440001",
        address: "192.168.1.100"
    },
    {
        id: "550e8400-e29b-41d4-a716-446655440002",
        address: "https://example.com:8080"
    },
    {
        id: "550e8400-e29b-41d4-a716-446655440003",
        address: "10.0.0.50"
    },
    {
        id: "550e8400-e29b-41d4-a716-446655440004",
        address: "https://blast.qrypt.io"
    }
];
const basicResponse = {
    success: true,
    message: "BLAST endpoint operation successful",
    error_code: null
};
export const blastEndpointsQueryHandlers = [
    http.get("/api/admin/blast-endpoints", ()=>{
        const res = {
            endpoints: mockBLASTEndpoints
        };
        return HttpResponse.json(res);
    })
];
export const blastEndpointsMutationHandlers = [
    // POST - Create BLAST endpoints (bulk)
    http.post("/api/admin/blast-endpoints", async ({ request })=>{
        const body = await request.json();
        const createdEndpoints = body.endpoints.map((endpoint)=>({
                id: crypto.randomUUID(),
                address: endpoint.address
            }));
        // Add to mock data
        mockBLASTEndpoints.push(...createdEndpoints);
        console.log("MSW: Created BLAST endpoints:", createdEndpoints);
        const res = {
            endpoints: createdEndpoints
        };
        return HttpResponse.json(res);
    }),
    // PUT - Update BLAST endpoint
    http.put("/api/admin/blast-endpoints/:id", async ({ params, request })=>{
        const { id } = params;
        const body = await request.json();
        const endpointIndex = mockBLASTEndpoints.findIndex((ep)=>ep.id === id);
        if (endpointIndex === -1) {
            return new HttpResponse(null, {
                status: 404,
                statusText: "BLAST endpoint not found"
            });
        }
        mockBLASTEndpoints[endpointIndex] = {
            ...mockBLASTEndpoints[endpointIndex],
            address: body.address
        };
        console.log("MSW: Updated BLAST endpoint:", mockBLASTEndpoints[endpointIndex]);
        return HttpResponse.json({
            ...basicResponse,
            message: "BLAST endpoint updated successfully"
        });
    }),
    // DELETE - Delete BLAST endpoint
    http.delete("/api/admin/blast-endpoints/:id", ({ params })=>{
        const { id } = params;
        const endpointIndex = mockBLASTEndpoints.findIndex((ep)=>ep.id === id);
        if (endpointIndex === -1) {
            return new HttpResponse(null, {
                status: 404,
                statusText: "BLAST endpoint not found"
            });
        }
        const deletedEndpoint = mockBLASTEndpoints[endpointIndex];
        mockBLASTEndpoints.splice(endpointIndex, 1);
        console.log("MSW: Deleted BLAST endpoint:", deletedEndpoint);
        return HttpResponse.json({
            ...basicResponse,
            message: "BLAST endpoint deleted successfully"
        });
    })
];
const blastEndpointsHandlers = [
    ...blastEndpointsQueryHandlers,
    ...blastEndpointsMutationHandlers
];
export default blastEndpointsHandlers;
